"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAssociatedAssetsProperty = exports.associatedAssetsPropertyDefinition = void 0;
exports.associatedAssetsPropertyDefinition = {
    view: {
        label: 'Associated asset',
        hint: 'The events, occasion campaigns, project profiles or energy drinks this promotion is associated with.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'energy-drink',
                'event-profile',
                'occasion-campaign',
                'project-profile',
            ],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'associated-assets',
};
const isAssociatedAssetsProperty = (prop) => {
    return prop.name === exports.associatedAssetsPropertyDefinition.name;
};
exports.isAssociatedAssetsProperty = isAssociatedAssetsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXNzb2NpYXRlZC1hc3NldHMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9hc3NvY2lhdGVkLWFzc2V0cy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxrQkFBa0I7UUFDekIsSUFBSSxFQUFFLHNHQUFzRztLQUM3RztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFO2dCQUNSLGNBQWM7Z0JBQ2QsZUFBZTtnQkFDZixtQkFBbUI7Z0JBQ25CLGlCQUFpQjthQUNsQjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLG1CQUFtQjtDQUNNLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDBDQUFrQyxDQUFDLElBQUksQ0FBQTtBQUM5RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==